import React, { useState, useEffect, useRef } from 'react';
import { useAtomValue } from 'jotai';
import PropTypes from 'prop-types';
import MediaDialog from '../Media';
import empty from '../../../../assets/images/empty.png';
import '../css/editorImage.scss';
import { selectedBranchAtom } from '../../../../Atoms';

const EditorImage = function EditorImage({
  id,
  edit = false,
  onChange = () => {},
  forEmail = false,
  ...props
}) {
  const errorCount = useRef(0);
  const { mediaId, alt, style, branchId, ...others } = props;

  const selectedBranch = useAtomValue(selectedBranchAtom);
  const [source, setSource] = useState(mediaId);
  const [mediaDialog, setMediaDialog] = useState(false);

  const handleOpenMedia = () => {
    setMediaDialog(true);
  };

  const handleCloseMedia = () => {
    setMediaDialog(false);
  };

  const handleSelectMedia = (mId) => () => {
    setSource(mId);
    handleCloseMedia();
  };

  useEffect(() => {
    setSource(mediaId);
  }, [mediaId]);

  useEffect(() => {
    errorCount.current = 0;
    if (source) {
      onChange({
        id,
        ...props,
        mediaId: source,
        branchId: '{branch.id}',
      });
    }
  }, [source]);

  return (
    <>
      <MediaDialog
        open={mediaDialog}
        onClose={handleCloseMedia}
        onConfirm={handleSelectMedia}
      />
      {!source ? (
        <div
          className="insertImage"
          aria-hidden="true"
          role="button"
          onClick={handleOpenMedia}
          style={{ aspectRatio: 1.5, cursor: edit && 'pointer', ...style }}
          {...others}
        />
      ) : (
        <img
          id={id}
          key={id}
          aria-hidden="true"
          onClick={edit ? handleOpenMedia : null}
          src={`${window.databeasy?.API_URL}Engagement/media/${encodeURIComponent(source)}/${edit ? encodeURIComponent(selectedBranch?.id) : branchId}`}
          onError={
            forEmail && !edit
              ? undefined
              : (e) => {
                  const event = e;
                  if (errorCount.current > 0) {
                    event.target.src = empty;
                    event.onError = null;
                  } else {
                    event.target.src = `${window.databeasy?.API_URL}Engagement/media/${encodeURIComponent(source)}/${selectedBranch?.id}`;
                    errorCount.current += 1;
                  }
                }
          }
          alt={alt}
          style={{
            maxWidth: '100%',
            height: 'auto',
            alignSelf: 'flex-start',
            ...style,
            cursor: edit && 'pointer',
          }}
          {...others}
        />
      )}
    </>
  );
};

EditorImage.propTypes = {
  id: PropTypes.string.isRequired,
  edit: PropTypes.bool,
  onChange: PropTypes.func,
  mediaId: PropTypes.string,
  alt: PropTypes.string,
  style: PropTypes.object,
  branchId: PropTypes.string,
};

export default EditorImage;
